export default "__VITE_ASSET__BdoggvkN__";